import React, { useState, useMemo } from "react";
import DataTable from "components/DataTable";
import PageWrapper from "components/PageWrapper";
import { useTableData } from "../../hooks/useTableData";
import { intraWalletReportConfig } from "config/tableConfigs";
import { useSession } from "hooks/useSession";

const IntraWalletReportsPage = () => {
  const { userid, role } = useSession();
  const [loading] = useState(false);

  const getLast7Days = () => {
    const today = new Date();
    const last7 = new Date();
    last7.setDate(today.getDate() - 1);

    return {
      start: last7.toISOString().split("T")[0],
      end: today.toISOString().split("T")[0],
    };
  };

  const { start, end } = getLast7Days();

  const [apiUrl, setApiUrl] = useState(
    `https://api.mokshiq.in/intra_wallet_report?user=${userid}&filter_date=${start}&end_date=${end}`
  );

  const tableData = useTableData(apiUrl, 0, intraWalletReportConfig);

  const handleDateFilter = (s, e) => {
    setApiUrl(
      `https://api.mokshiq.in/intra_wallet_report?user=${userid}&filter_date=${s}&end_date=${e}`
    );
  };

  const filteredConfig = useMemo(() => {
    const base = {
      ...intraWalletReportConfig,
      columns: [...intraWalletReportConfig.columns],
    };

    const roleMap = {
      Retailer: [
        "id",
        "ref_no",
        "ack_no",
        "transection_type",
        "product",
        "sender_phone",
        "receiver_phone",
        "sender_name",
        "receiver_name",
        "amount",
        "created_at",
        "status",
        "Opening Balance",
        "Commission",
        "TDS",
        "Charge",
        "GST",
        "Closing Balance",
      ],

      Distributer: [
        "id",
        "ref_no",
        "ack_no",
        "transection_type",
        "product",
        "number",
        "amount",
        "created_at",
        "status",
        "Opening Balance Dist",
        "Commission Dist",
        "TDS Dist",
        "Charge Dist",
        "GST Dist",
        "Closing Balance Dist",
      ],

      "Super Distributer": [
        "id",
        "ref_no",
        "ack_no",
        "transection_type",
        "product",
        "number",
        "amount",
        "created_at",
        "status",
        "Opening Balance SuperDist",
        "Commission SuperDist",
        "TDS SuperDist",
        "Charge SuperDist",
        "GST SuperDist",
        "Closing Balance SuperDist",
      ],

      Admin: [
        "ID",
        "BC Name",
        "Product Type",
        "Product",
        "Amount",
        "Opening Balance Admin",
        "Closing Balance Admin",
        "Opening Balance",
        "Closing Balance",
        "Customer No",
        "Status",
        "Wallet Txn",
        "TXN Flow",
        "created_at",
      ],

      "Main Admin": base.columns.map((c) => c.key),
    };

    const allowedKeys = roleMap[role] || [];
    base.columns = base.columns.filter((c) =>
      allowedKeys.includes(c.key)
    );

    return base;
  }, [role]);

  return (
    <PageWrapper
      config={intraWalletReportConfig}
      onDateFilter={handleDateFilter}
    >
      <DataTable
        config={filteredConfig}
        tableData={tableData}
      />
    </PageWrapper>
  );
};

export default IntraWalletReportsPage;
